import mdl from '@/models/Accounting/AccAccountingSeat'

const includes = ['g_generator_user.hr_employee', 'acc_accounting_seat_status', 'acc_accounting_seat_type']

const findAccountingSeat = async id => {
    try {
        let response = await mdl.include(includes).find(id)
        return response
    } catch (error) {
        return error.response
    }
}

export { findAccountingSeat }
